import React, { PureComponent } from 'react';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer
} from '../../../components/ui';

import ImageSource from '../../../../../../containers/assets/peer-feedback-strength-areas-of-development.png';

class TheIndividual extends PureComponent {

  render() {
    return (
      <Wrapper>
        <PreTitle>Individual</PreTitle>
        <Title>The Individual</Title>
        <Text>Exploring the individual</Text>
        <ContentContainer transparent={true}>
          <img src={ImageSource} alt="Engagement Score" />
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default TheIndividual;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/dynamics/individual/the-individual.js